import { Outlet, Link } from 'react-router-dom'
import { Phone, Mail, MapPin, Menu, X } from 'lucide-react'
import { useState } from 'react'

export function Layout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/doctors', label: 'Doctors' },
    { path: '/departments', label: 'Departments' },
    { path: '/contact', label: 'Contact' },
    { path: '/appointment', label: 'Book Appointment' },
  ]

  return (
    <div className="min-h-screen bg-background">
      {/* Top bar */}
      <div className="bg-primary text-white py-2 px-4">
        <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-2 text-sm">
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1"><Phone size={14} /> 09610009620</span>
            <span className="flex items-center gap-1"><Mail size={14} /> info@fastaid.com.bd</span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/portal/login" className="hover:text-primary-light transition-colors">Patient Portal</Link>
          </div>
        </div>
      </div>

      {/* Navbar */}
      <nav className="bg-surface border-b border-border sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="text-xl font-bold text-primary">Fast Aid Hospital</Link>
            <div className="hidden md:flex items-center gap-6">
              {navLinks.map((link) => (
                <Link key={link.path} to={link.path} className="text-text hover:text-primary transition-colors">{link.label}</Link>
              ))}
            </div>
            <button className="md:hidden" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-border bg-surface">
            {navLinks.map((link) => (
              <Link key={link.path} to={link.path} className="block px-4 py-3 text-text hover:bg-background" onClick={() => setMobileMenuOpen(false)}>{link.label}</Link>
            ))}
          </div>
        )}
      </nav>

      <main>
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-text text-white mt-12">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-lg font-bold mb-4">Fast Aid Hospital</h3>
              <p className="text-gray-300 text-sm">A 24/7 medical care and diagnostic centre providing quality healthcare services to the community of Chauddagram and surrounding areas.</p>
            </div>
            <div>
              <h3 className="text-lg font-bold mb-4">Contact</h3>
              <div className="space-y-2 text-sm text-gray-300">
                <p className="flex items-center gap-2"><MapPin size={16} /> Chauddagram, Chittagong</p>
                <p className="flex items-center gap-2"><Phone size={16} /> 09610009620</p>
                <p className="flex items-center gap-2"><Mail size={16} /> info@fastaid.com.bd</p>
              </div>
            </div>
            <div>
              <h3 className="text-lg font-bold mb-4">Quick Links</h3>
              <div className="space-y-2 text-sm text-gray-300">
                <Link to="/about" className="block hover:text-white">About Us</Link>
                <Link to="/doctors" className="block hover:text-white">Our Doctors</Link>
                <Link to="/appointment" className="block hover:text-white">Book Appointment</Link>
                <Link to="/portal/login" className="block hover:text-white">Patient Portal</Link>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-4 text-center text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Fast Aid Hospital, Chauddagram. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  )
}
